import clsx from 'clsx';
import React from 'react';

import { UserType } from '../../types';

const TABLE_HEADER_STYLE =
  'pb-8 text-left font-suisse-intl text-button-sm font-normal text-grayscale-gray';

interface TableHeaderProps {
  userType: UserType;
}

const TableHeader = ({ userType }: TableHeaderProps) => (
  <thead>
    <tr>
      <th
        className={clsx('w-[110px] xs:w-[160px] sm:w-[228px] md:w-[180px]', TABLE_HEADER_STYLE, {
          'hidden sm:block': userType === UserType.Active,
          block: userType !== UserType.Active,
        })}
      >
        Name
      </th>
      <th className={clsx('w-full', TABLE_HEADER_STYLE)}>Email address</th>
      {userType === UserType.Active && (
        <th className={clsx('block w-[60px]', TABLE_HEADER_STYLE)}>Pro</th>
      )}
    </tr>
  </thead>
);

export default TableHeader;
